import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./categorias.component.html')
})
export class CategoriasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/categorias.component.ts
 **/